
                import { Component } from "/app/packages/open-source/blognami/lib/index.js";
                import { createDecoratorsInclude } from "/app/packages/open-source/blognami/lib/view_file_importers/js.js";
                import { decorators } from "/app/packages/open-source/blognami/lib/views/_blognami/_table.js";
                const hash = "fs96h35h0D";
                Component.include(createDecoratorsInclude(hash, decorators));
            